module.exports = __webpack_public_path__ + "img/yfh-thumb3.c88dc10a.png";